import { render, staticRenderFns } from "./Lgx241518381319061504.vue?vue&type=template&id=1e22e8ec&"
import script from "./Lgx241518381319061504.vue?vue&type=script&lang=js&"
export * from "./Lgx241518381319061504.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports